<template>
  <a
    class="ws-info-link"
    :href="value"
    target="_blank"
  >{{value}}</a>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-link.scss";
</style>